// src/components/ModalFormColor.jsx
import React, { useState, useEffect } from "react";
import { putColor } from "../helpers/rutaColores";
import { Modal, Button } from "react-bootstrap";
import "animate.css";

const ModalFormColor = ({ color, handleClose }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const [formValues, setFormValues] = useState({
    nombre: "",
  });

  useEffect(() => {
    if (color) {
      setFormValues({
        nombre: color?.nombre || "",
      });
    }
  }, [color]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: value.toUpperCase(),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!color?._id) {
      alert("No se encontró el id del color");
      return;
    }

    if (!formValues.nombre.trim()) {
      alert("Debe ingresar un color");
      return;
    }

    const payload = {
      nombre: formValues.nombre.trim().toUpperCase(),
    };

    try {
      const resp = await putColor(color._id, payload);

      if (resp?.ok === false) {
        console.error("❌ Error al actualizar color:", resp);
        alert(resp?.error?.error || resp?.error || "No se pudo actualizar el color");
        return;
      }

      console.log("✅ Color actualizado:", resp);

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        handleClose();
      }, 1000);
    } catch (error) {
      console.error("❌ Error al guardar color:", error);
      alert("Error al guardar color");
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="form-group mt-3">
            <label>Color</label>
            <input
              type="text"
              className="form-control"
              name="nombre"
              maxLength="50"
              minLength="2"
              required
              value={formValues.nombre}
              onChange={handleChange}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormColor;